import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
    en: {
        main: {
            welcome1: "Welcome to  IDCS MZ Centrs !",
            welcome2: "Create and send messages in three easy steps:",
            step1: "Create message template",
            step2: "Create list of recipients from file (MS Excel, XML, CSV)",
            step3: "Create task for sms messages sending",
            images: [
                { src: "/console/slides/1-1.jpg", txt: "Go to templates" },
                { src: "/console/slides/1-2.jpg", txt: "Create new template" },
                { src: "/console/slides/1-3.jpg", txt: "Create message text" },
                { src: "/console/slides/1-4.jpg", txt: "List of templates" },
                { src: "/console/slides/2-5.jpg", txt: "Go to lists of recipients" },
                { src: "/console/slides/2-6.jpg", txt: "Create new list of recipients" },
                { src: "/console/slides/2-7.jpg", txt: "Name of the list" },
                { src: "/console/slides/2-8.jpg", txt: "Select source of list" },
                { src: "/console/slides/2-9.jpg", txt: "Select Excel file for import" },
                { src: "/console/slides/2-10.jpg", txt: "Select column with phones" },
                { src: "/console/slides/2-11.jpg", txt: "Save list" },
                { src: "/console/slides/3-12.jpg", txt: "Go to task scheduler" },
                { src: "/console/slides/3-13.jpg", txt: "Create a new task" },
                { src: "/console/slides/3-14.jpg", txt: "Enter data of the task" },
                { src: "/console/slides/3-15.jpg", txt: "Plane task" },
                { src: "/console/slides/3-16.jpg", txt: "Plane start of the task" },
                { src: "/console/slides/3-17.jpg", txt: "Check new status of the task" }
            ]
        },
        tooltip: {
            limit: "Credit amount",
            available: "Available founds for new tasks",
            reserved: "Reserved founds for scheduled tasks",
            listedit: "Toggle column and record edit mode",
            taskopen: "Open sending control",
            listopen: "View list of recipients"
        },
        title: {
            main: "IDCS MZ CENTRS",
            sheduler: "Scheduler Tasks",
            lists: "Recipient Lists",
            templates: "Message Templates",
            history: "Sending History",
            finance: "Financial Reports"
        },
        menu: {
            logout: "LogOff",
            sheduler: "Scheduler",
            lists: "Recipients",
            templates: "Templates",
            history: "History",
            finance: "Finances",
            admin: "Administration"
        },
        admin: {
            AdminUsers: "Users",
            user: "User",
            AdminCompanies: "Companies",
            AdminSmsapi: "SMS API",
            company: "Company",
            smsapi: "SMS api",
            AdminTasks: "Tasks",
            AdminLists: "Lists",
            AdminMessages: "Messages",
            AdminEvents: "Events",
            AdminFinances: "Finances",
            AdminTemplates: "Templates",
        },
        status: {
            _: "",
            _1: "Not Planned",
            _2: "Scheduled",
            _3: "In progress",
            _4: "Suspended",
            _5: "Completed",
            _6: "Removed from view",
            rec_1: "Active",
            rec_0: "Blocked"
        },
        // CANCELED, NOTASK, NOCOMPSETT, NOAPISETT, TASKSTAT, SENDER, APIURL, TARGETS, NOANSWER, WRONGURL, PROTOCOL, IO, RUNTIME, APISETT, NOTARGET, APIKEY
        complete: {
            _null: "",
            _1: "OK",
            _2: "Canceled",
            _3: "Task not found",
            _4: "System error (comp)",
            _5: "System error (api)",
            _6: "Wrong status",
            _7: "Wrong sender",
            _8: "System error (url)",
            _9: "No recipients",
            _10: "No answer",
            _11: "System error (url)",
            _12: "System error (protocol)",
            _13: "System error (io)",
            _14: "System error (rtapi)",
            _15: "System error (apisett)",
            _16: "System error (targets)",
            _17: "System error (apikey)",
            _18: "On your company account not enough money",
        },
        group: {
            _: "",
            _1: "Not Scheduled Task",
            _2: "Scheduled Task",
            _3: "Active Task",
            _4: "Tasks with errors",
        },
        evt: [
            { text: "broken", value: 0 },
            { text: "Sending registration", value: "1" },
            { text: "Receive result", value: "2" },
            { text: "Error", value: "3" },
            { text: "Warning", value: "4" },
            { text: "Sending", value: "5" },
            { text: "Login", value: "6" },
            { text: "Account operation", value: "6" },
            { text: "undefined", value: undefined },
            { text: "null", value: null },
        ],
        label: {
            search: "Search",
            limit: "Monthly credit is {limit}",
            slideshow: "Slideshow",
            search_f: "Search in",
            allFields: "All fields",
            saveAsName: "Enter new list name",
            rowPerPage: "Row per page",
            nodata: "No data found",
            select_date: "or select date and time for Start of task",
            sendat: "sending is scheduled at",
            params: "Available recipient parametrs",
            tarif: "Message sending price",
            import: "Finded {okcount} records with correct phone number",
            newparam: "Enter new data",
            importok: "Save {phok} records",
            importbad: "With error: ",
            bilance: "Available funds: {bilance}",
            reserved: "( reseved: {reserved} )"
        },
        fields: {
            lastError: "Last error",
            limit: "Month limit",
            tarifsuf: "(euro/10000)",
            control_phone_ph: "Phone for receiving copy of message",
            range: "Period",
            completed: "Sending status",
            amount: "Amount",
            remain: "Bilance",
            comment: "Comments",
            sourcetask: "Task details",

            impcol: "Field ",
            newkey: "Name",
            newval: "Data",
            phstatus: "Send ?",
            number: "Phone",
            file: "File of recipients datas",
            phfile: "Load from file",
            list: "list of recipients",
            template: "Messages templates",
            type: "Sending type",
            isAdmin: "Administrator",
            newpassword: "please enter new password",
            country: "Country",
            provider: "Mobile operator",
            state: "Phone number is correct",
            settings: "Settings",
            price: "Total cost",
            msgprice: "Message price",
            cprice: "Price",
            rprice: "Real price",
            recipient: "Phone number",
            sended: "Sended at",
            count: "Count of SMS",
            cparts: "Parts of message",
            rparts: "Real message count",
            respcode: "Response code",
            respdesc: "Response description",
            isutf: "Contains unicode",
            size: "Count of simbol",
            event: "Event",
            user: "User",
            task: "SMS sending",
            debit: "On your account",
            tarif: "Tariff",
            smsapi: "SMS api",
            user_name: "User name",
            company: "Company name",
            action: "",
            ended: "Completed",
            complete: "Complete status",
            pos: "#",
            text: "Message text",
            name: "Name",
            message: "Message text",
            created: "Created",
            updated: "Modified",
            scheduled: "Scheduled at",
            recipients: "Count of recipients",
            status: "Status",
            sender: "Sender",
            delimiter: "Delimiter",
            start: {
                lbl: "Sending start time",
                ph: "Please select start time of sending or press Start Now"
            }
        },
        delims: [
            { "value": ",", "text": "Comma" },
            { "value": ";", "text": "Semicolon" },
            { "value": "\t", "text": "Tab" },
        ],
        task_types: [
            { "value": 0, "text": "SMS" },
            { "value": 1, "text": "E-Mail" },
        ],
        recStatus: [
            { "value": 1, "text": "Active" },
            { "value": 0, "text": "Blocked" },
        ],
        button: {
            cancel: "Cancel",
            login: "Login",
            reset: "Reset",
            delete: "Delete",
            edit: "Edit",
            update: "Save",
            schedule: "Schedule start of sending",
            stop: "Stop sending",
            now: "Start Now",
            create: "Create",
            apply: "Apply",
            copy: "Copy",
            resend: "Restart sending",
            archive: "Delete",
            setdate: "Set sending time",
            impremove: "Delete records w/o phone number",
            edittask: "Add personal information"
        },
        login: {
            title: "Authorization",
            login: "User",
            pass: "Password"
        },
        error: {
            required: "This field is required",
            date: "Please select the correct date!",
            phone: "Lenght of phone must be 8 digits",
            login: "User name or password is not correct",
            paramname: "Only latin letters or digits is passible",
            dublicate: "Dublicated value"
        },
        dialog: {
            newtask: "New task for sending",
            createlist: "New list of recipients",
            plane: "Scheduling of start sending",
            editmsg: "Editing sending data",
            editlistrec: "Editing recipient data",
            edit_template: "SMS message text",
            copylist: "Save selected records to new list",
            ttl: {
                delete: "Please confirm",
                deleteList: "Please confirm",
                deleteNumber: "Please confirm",
                deleteParam: "Please confirm",
                deleteTemplate: "Please confirm",
                deleteImportRow: "Please confirm",
                deleteImportCol: "Please confirm",
                stop: "Please confirm",
                start: "Please confirm",
                archive: "Please confirm",
                reset: "Please confirm",
                save: "Attention",
                param: "Change the parametr {param} "
            },
            txt: {
                delCompany: "Delete company?",
                delete: "Delete sending ?",
                deleteList: "Delete recipients list ?",
                deleteNumber: "Delete phone from list ?",
                deleteImportRow: "Delete record ?",
                deleteImportCol: "Delete parametr ?",
                deleteTemplate: "Delete message template ?",
                deleteParam: "Delete parametr for all recipients ?",
                start: "Start the task?",
                stop: "Stop the task?",
                archive: "Delete this task?",
                reset: "Cancel the task?",
                save: "Data is changed, but not saved!"
            },
            ico: {
                delete: "mdi-trash-can-outline",
                deleteList: "mdi-trash-can-outline",
                deleteNumber: "mdi-trash-can-outline",
                deleteTemplate: "mdi-trash-can-outline",
                deleteImportCol: "mdi-trash-can-outline",
                deleteImportRow: "mdi-trash-can-outline",
                deleteParam: "mdi-trash-can-outline",
                stop: "mdi-close-thick",
                reset: "mdi-close-thick",
                archive: "mdi-trash-can-outline",
                start: ""
            },
            btn: {
                delete: "Delete",
                deleteList: "Delete",
                deleteParam: "Delete",
                deleteTemplate: "Delete",
                deleteNumber: "Delete",
                deleteImportRow: "Delete",
                deleteImportCol: "Delete",
                start: "Start",
                stop: "Stop",
                archive: "Delete",
                reset: "Reset",
                nosave: "Exit w/o save",
                saveclose: "Save and exit",
                cancel: "Cancel",
            }
        }
    },
    ru: {
        main: {
            welcome1: "Добро пожаловать в IDCS центр маркетинговых сообщений !",
            welcome2: "Создание и рассылка сообщений в три простых шага:",
            step1: "Создание шаблона сообщения",
            step2: "Создание списка получателей из файла (MS Excel, XML, CSV)",
            step3: "Создание задания на рассылку СМС",
            images: [
                { src: "/console/slides/1-1.jpg", txt: "Переход в раздел шаблонов сообщений" },
                { src: "/console/slides/1-2.jpg", txt: "Создание нового шаблона" },
                { src: "/console/slides/1-3.jpg", txt: "Создание текста сообщения" },
                { src: "/console/slides/1-4.jpg", txt: "Список готовых шаблонов" },
                { src: "/console/slides/2-5.jpg", txt: "Переход в раздел списков получателей" },
                { src: "/console/slides/2-6.jpg", txt: "Создание нового списка получателей" },
                { src: "/console/slides/2-7.jpg", txt: "Название списка" },
                { src: "/console/slides/2-8.jpg", txt: "Выбор источника списка" },
                { src: "/console/slides/2-9.jpg", txt: "Выбор файла Excel для импорта данных получателей" },
                { src: "/console/slides/2-10.jpg", txt: "Указание раздела с номерами телефонов получателей" },
                { src: "/console/slides/2-11.jpg", txt: "Сохранение списка" },
                { src: "/console/slides/3-12.jpg", txt: "Переход в раздел планирования рассылки" },
                { src: "/console/slides/3-13.jpg", txt: "Создание задания на рассылку" },
                { src: "/console/slides/3-14.jpg", txt: "Заполнение информации для задания" },
                { src: "/console/slides/3-15.jpg", txt: "Переход к планированию запуска" },
                { src: "/console/slides/3-16.jpg", txt: "Планирование времени запуска или немедленный запуск рассылки" },
                { src: "/console/slides/3-17.jpg", txt: "Результат создания задания" }
            ]
        },
        title: {
            main: "IDCS MZ CENTRS",
            sheduler: "Управление рассылками",
            lists: "Управление списками получателей",
            templates: "Шаблоны сообщений",
            history: "История отправок",
            finance: "Финасовый отчет"
        },
        menu: {
            logout: "Выход",
            sheduler: "Планировщик",
            lists: "Списки клиентов",
            templates: "Шаблоны сообщений",
            history: "История",
            finance: "Финансы",
            admin: "Администрирование"
        },
        tooltip: {
            limit: "Доступная месячная кредитная линия ",
            available: "Доступные к использованию средства",
            reserved: "Зарезериванные средства для запланированных рассылок",
            listedit: "Вкл/выкл режима редактирования списка",
            taskopen: "Переход в управление рассылкой",
            listopen: "Переход к редактированию списка получателей"
        },
        admin: {
            AdminUsers: "Пользователи",
            user: "User",
            AdminCompanies: "Компании",
            AdminSmsapi: "SMS API",
            company: "Company",
            smsapi: "SMS api",
            AdminTasks: "Рассылки",
            AdminLists: "Списки",
            AdminMessages: "Сообщения",
            AdminEvents: "Журнал",
            AdminFinances: "Финансы",
            AdminTemplates: "Шаблоны",
        },
        status: {
            _: "",
            _1: "Не запланирована",
            _2: "Запланирована",
            _3: "В процессе",
            _4: "Приостановлена",
            _5: "Завершена",
            _6: "Удалена из просмотров",
            rec_1: "Active",
            rec_0: "Blocked"
        },
        complete: {
            _null: "",
            _1: "Успешная отправка",
            _2: "Прервано",
            _3: "Ошибка поиска",
            _4: "Системная ошибка (настройка организации)",
            _5: "Системная ошибка (настройка поставщика услуги)",
            _6: "Неверный статус",
            _7: "Неверный отправитель",
            _8: "Системная ошибка (настройка поставщика услуги)",
            _9: "У рассылки нет получателей",
            _10: "Системная ошибка (поставщик услуг не ответил)",
            _11: "Системная ошибка (url)",
            _12: "Системная ошибка (protocol)",
            _13: "Системная ошибка (io)",
            _14: "Системная ошибка (rtapi)",
            _15: "Системная ошибка (apisett)",
            _16: "Системная ошибка (targets)",
            _17: "Системная ошибка (apikey)",
            _18: "На счету вашей организации недостаточно средств",
        },
        group: {
            _: "",
            _1: "В ожидании планирования времени рассылки",
            _2: "Запланированнные рассылки",
            _3: "Активные рассылки",
            _4: "Приостановленные рассылки",
        },
        //broken, registration, result, error, warning, sending, login, debit
        evt: [
            { text: "broken", value: 0 },
            { text: "Регистрация отсылки", value: "1" },
            { text: "Прием результата", value: "2" },
            { text: "Ошибка", value: "3" },
            { text: "Предупреждение", value: "4" },
            { text: "Отсылка", value: "5" },
            { text: "Вход в систему", value: "6" },
            { text: "Пополнение счета", value: "6" },
            { text: "undefined", value: undefined },
            { text: "null", value: null },
        ],
        label: {
            limit: "Месячный кредит {limit}",
            reserved: "Зарезервировано {reserved}",
            search: "Поиск",
            rowPerPage: "Записей на странице",
            nodata: "Нет данных",
            select_date: "или укажите дату и время начала рассылки",
            sendat: "отправка назначена на",
            params: "Доступные параметры получателя",
            tarif: "Цена отправки сообщения",
            import: "Найдено {okcount} записей, с корректным номером телефона",
            newparam: "Введите значения для нового параметра",
            importok: "Сохранить {phok} записей",
            importbad: "Ошибочны: ",
            bilance: "На вашем счету доступно {bilance}",
            slideshow: "Автоматическое переключение слайдов",
            search_f: "Искать в поле",
            allFields: "Все поля",
            saveAsName: "Введите имя нового списка"
        },
        fields: {
            control_phone_ph: "Телефон для получения копии сообщения",
            lastError: "Ошибка",
            limit: "Месячный лимит",
            tarifsuf: "(euro/10000)",

            range: "Выборка за период",
            completed: "Статус отправки",
            amount: "Сумма",
            remain: "Остаток",
            comment: "Комментарий",
            sourcetask: "Просмотреть детали",

            impcol: "Поле ",
            newkey: "Название",
            newval: "Значение",
            phstatus: "Отсылать ?",
            number: "Телефон",
            file: "Файл со списком телефонов",
            phfile: "Загрузить из файла",
            list: "Список получателей",
            template: "Шаблон сообщения",
            type: "Тип рассылки",
            isAdmin: "Администратор",
            newpassword: "введите новый пароль",
            country: "Страна",
            provider: "Мобильный оператор",
            state: "Статус проверки",
            settings: "Settings",
            price: "Общая стоимость",
            msgprice: "Стоимость сообщения",
            cprice: "Price",
            rprice: "Real price",
            recipient: "Номер телефона",
            sended: "Sended at",
            count: "Кол-во sms",
            cparts: "Кол-во сообщений",
            rparts: "Real message count",
            respcode: "Response code",
            respdesc: "Response description",
            isutf: "Содержит национальные буквы",
            size: "Кол-во символов",
            event: "Событие",
            user: "Пользователь",
            task: "Рассылка",
            debit: "Остаток средств",
            tarif: "Тариф",
            smsapi: "SMS api",
            user_name: "Имя пользователя",
            company: "Название компании",
            action: "",
            ended: "Завершена",
            complete: "Complete status",
            pos: "#",
            text: "Текст сообщения",
            name: "Название",
            message: "Текст сообщения",
            created: "Создана",
            updated: "Изменена",
            scheduled: "Время отправки",
            recipients: "Кол-во получателей",
            status: "Status",
            sender: "Отправитель",
            delimiter: "Разделитель",
            start: {
                lbl: "Время начала рассылки",
                ph: "Назначьте время отправки, по умолчанию будет отправлено сразу"
            }
        },
        delims: [
            { "value": ",", "text": "Запятая" },
            { "value": ";", "text": "Точка с запятой" },
            { "value": "\t", "text": "Табуляция" },
        ],
        task_types: [
            { "value": 0, "text": "SMS" },
            { "value": 1, "text": "E-Mail" },
        ],
        recStatus: [
            { "value": 1, "text": "Активна" },
            { "value": 0, "text": "Блокирована" },
        ],
        button: {
            cancel: "Отменить",
            login: "Войти",
            reset: "Сбросить",
            delete: "Удалить",
            edit: "Редактировать",
            update: "Сохранить",
            schedule: "Запланировать рассылку",
            stop: "Отменить рассылку",
            now: "Начать рассылку сейчас",
            create: "Создать",
            apply: "Применить",
            copy: "Скопировать",
            resend: "Повторить отсылку",
            archive: "Удалить",
            setdate: "Установить время рассылки",
            impremove: "Удалить ошибочные записи",
            edittask: "Персонализировать"
        },
        login: {
            title: "Авторизация",
            login: "Пользователь",
            pass: "Пароль"
        },
        error: {
            required: "Это поле необходимо заполнить",
            date: "Select correct date. Must be after now",
            phone: "Lenght must be 8 or more digits",
            login: "Пользователь или пароль не верны!",
            paramname: "Имя может содержать только латинские буквы и цифры"
        },
        dialog: {
            newtask: "Новая задача на отправку сообщений",
            createlist: "Создание списка получателей",
            plane: "Планирование начала рассылки",
            editmsg: "Редактировать рассылку",
            editlistrec: "Редактирование получателя",
            edit_template: "Текст SMS сообщения",
            copylist: "Копирование выбранных данных",
            ttl: {
                delete: "Подтвердите действие",
                deleteList: "Подтвердите действие",
                deleteNumber: "Подтвердите действие",
                deleteParam: "Подтвердите действие",
                deleteTemplate: "Подтвердите действие",
                deleteImportRow: "Подтвердите действие",
                deleteImportCol: "Подтвердите действие",
                stop: "Подтвердите действие",
                start: "Подтвердите действие",
                archive: "Подтвердите действие",
                reset: "Подтвердите действие",
                save: "Предупреждение",
                param: "Изменение параметра {param} "
            },
            txt: {
                delCompany: "Удалить компанию ?",
                delete: "Удалить рассылку ?",
                deleteList: "Удалить список телефонов ?",
                deleteNumber: "Удалить телефон из списка ?",
                deleteImportRow: "Удалить запись ?",
                deleteImportCol: "Удалить параметр ?",
                deleteTemplate: "Удалить текст сообщения из списка ?",
                deleteParam: "Удалить параметр у всех телефонов ?",
                start: "Start the task?",
                stop: "Stop the task?",
                archive: "Delete this task?",
                reset: "Отменить рассылку?",
                save: "Данные списка были изменены, но не были сохранены. Выберите ваше действие "
            },
            ico: {
                delete: "mdi-trash-can-outline",
                deleteList: "mdi-trash-can-outline",
                deleteNumber: "mdi-trash-can-outline",
                deleteTemplate: "mdi-trash-can-outline",
                deleteImportCol: "mdi-trash-can-outline",
                deleteImportRow: "mdi-trash-can-outline",
                deleteParam: "mdi-trash-can-outline",
                stop: "mdi-close-thick",
                reset: "mdi-close-thick",
                archive: "mdi-trash-can-outline",
                start: ""
            },
            btn: {
                delete: "Удалить",
                deleteList: "Удалить",
                deleteParam: "Удалить",
                deleteTemplate: "Удалить",
                deleteNumber: "Удалить",
                deleteImportRow: "Удалить",
                deleteImportCol: "Удалить",
                start: "Запустить",
                stop: "Остановить",
                archive: "Удалить",
                reset: "Сбросить",
                nosave: "Не сохранять и выйти",
                saveclose: "Сохранить и выйти",
                cancel: "Отменить",
            }
        }
    },
    lv: {
        main: {
            welcome1: "Laipni lūgti IDCS mārketinga ziņu centrā!",
            welcome2: "Ziņu sagatavošana un izsūtīšana trīs vienkāršos soļos:",
            step1: "Ziņas sagataves izveidošana",
            step2: "Saņēmēju saraksta izveidošana no failiem (MS Excel, XML, CSV)",
            step3: "Izsūtīšanas uzdevumu izveidošana",
            images: [
                { src: "/console/slides/1-1.jpg", txt: "Ziņas sagataves izvēlne" },
                { src: "/console/slides/1-2.jpg", txt: "Jauna ziņas sagataves izveidošana" },
                { src: "/console/slides/1-3.jpg", txt: "Ziņas teksta izveidošana" },
                { src: "/console/slides/1-4.jpg", txt: "Gatavo ziņu sagatavju saraksts" },
                { src: "/console/slides/2-5.jpg", txt: "Saņēmēju sarakstu izvēlne" },
                { src: "/console/slides/2-6.jpg", txt: "Jauna saņēmēju saraksta izveidošana" },
                { src: "/console/slides/2-7.jpg", txt: "Saraksta nosaukums" },
                { src: "/console/slides/2-8.jpg", txt: "Saraksta datu avota izvēlne" },
                { src: "/console/slides/2-9.jpg", txt: "Excel faila izvēlne datu importam" },
                { src: "/console/slides/2-10.jpg", txt: "Sadaļas ar telefona numuriem noradīšana" },
                { src: "/console/slides/2-11.jpg", txt: "Saraksta saglabāšana" },
                { src: "/console/slides/3-12.jpg", txt: "Planotāja izvēlne" },
                { src: "/console/slides/3-13.jpg", txt: "Izsūtīšanas uzdevumu izveidošana" },
                { src: "/console/slides/3-14.jpg", txt: "Uzdevuma informācijas ievade" },
                { src: "/console/slides/3-15.jpg", txt: "Izsūtīšanas plānošanas izvēlne" },
                { src: "/console/slides/3-16.jpg", txt: "Izsūtīšanas laiku plānošana vai tūlītēja izsūtīšana" },
                { src: "/console/slides/3-17.jpg", txt: "Izsūtīšana ir ieplānota veiksmīgi" }
            ]
        },
        title: {
            main: "IDCS MZ CENTRS",
            sheduler: "Izsūtīšanas vadība",
            lists: "Saņēmēju saraksti",
            templates: "Ziņojumu sagataves",
            history: "Izsūtnes vēsture",
            finance: "Finansu atskaite"
        },
        menu: {
            logout: "Izeja",
            sheduler: "Plānotājs",
            lists: "Saņēmēju saraksti",
            templates: "Ziņojumu sagataves",
            history: "Vēsture",
            finance: "Finanses",
            admin: "Administrēšana"
        },
        admin: {
            AdminUsers: "Lietotājs",
            user: "Lietotājs",
            AdminCompanies: "Uzņēmums",
            AdminSmsapi: "SMS API",
            company: "Uzņēmums",
            smsapi: "SMS api",
            AdminTasks: "Izsūtīšanas",
            AdminLists: "Saņēmēju saraksti",
            AdminMessages: "Ziņojumi",
            AdminEvents: "Notikumi",
            AdminFinances: "Finanses",
            AdminTemplates: "Ziņojumu teksti",
        },
        status: {
            _: "",
            _1: "Nav ieplānots",
            _2: "Ieplānots",
            _3: "Procesā",
            _4: "Apturēts",
            _5: "Pabeigts",
            _6: "Arhivēts",
            rec_1: "Aktīvs",
            rec_0: "Bloķēts"
        },
        group: {
            _: "",
            _1: "Izsūtnes laiks nav uzstādīts",
            _2: "Ieplānotas izsūtnes",
            _3: "Aktīvas izsūtnes",
            _4: "Apturētas izsūtnes",
        },
        //registration, result, error, warning, sending, login, debit
        evt: [
            { text: "Kļūdains ieraksts (0)", value: 0 },
            { text: "Izsūtīšanas saņemšana no E-Kartes", value: "1" },
            { text: "Atbilde no SMS API", value: "2" },
            { text: "Kļūda", value: "3" },
            { text: "Brīdīnājums", value: "4" },
            { text: "Izsūtīšanas sākums", value: "5" },
            { text: "Ieeja sistēmā", value: "6" },
            { text: "Konta papildināšana", value: "6" },
            { text: "Kļūdains ieraksts (UNDEF)", value: undefined },
            { text: "Kļūdains ieraksts (NULL)", value: null },
        ],
        complete: {
            _null: "",
            _1: "Veiksmīgi",
            _2: "Kļūda",
            _3: "Kļūda",
            _4: "Sistēmas kļūda (uzņēmuma uzstādījumos)",
            _5: "Sistēmas kļūda (SMS API)",
            _6: "Kļūda (Status)",
            _7: "Kļūda (Nosūtītājs)",
            _8: "Sistēmas kļūda (SMS API)",
            _9: "Nav saņēmēju",
            _10: "Sistēmas kļūda (Savienojuma kļūda)",
            _11: "Sistēmas kļūda (url)",
            _12: "Sistēmas kļūda (protocol)",
            _13: "Sistēmas kļūda (io)",
            _14: "Sistēmas kļūda (rtapi)",
            _15: "Sistēmas kļūda (apisett)",
            _16: "Sistēmas kļūda (targets)",
            _17: "Sistēmas kļūda (apikey)",
            _18: "Nepietiek naudas kontā",
        },
        tooltip: {
            limit: "Pieejamais mēneša kredīta limits ",
            available: "Pieejamie līdzekļi lietošanai",
            reserved: "Rezervētie līdzekļī ieplānotām izsūtīšanām",
            listedit: "Iesl/Izsl rediģēšanas režīmu",
            taskopen: "Pārēja uz izsūtīšanas vadības režīmu",
            listopen: "Pārēja uz saņēmēju sarakstu rediģēšanu"
        },
        label: {
            limit: "Mēneša kredīts {limit}",
            reserved: "Rezervēts {reserved}",
            saveAsName: "Ievadiet jaunā saraksta nosaukumu",
            search_f: "Mēklēt",
            search: "Mēklēt",
            allFields: "Visos laukos",
            slideshow: "Slaidrāde",
            rowPerPage: "ierakstu skaits lapā",
            nodata: "Dati nav atrasti",
            select_date: "vai norādiet izsūtnes datumu un laiku",
            sendat: "izsūtne ieplānota uz",
            params: "Saņemēja pieejamie dati",
            tarif: "SMS cena",
            import: "Atrasti {okcount} ieraksti ar pareiziem tālruņa numuriem",
            newparam: "Pievienojiet jaunus papildu datus",
            importok: "Saglabāt {phok} ierakstus",
            importbad: "Kļūdaini: ",
            bilance: "Jūsu kontā pieejams {bilance}"
        },
        fields: {
            control_phone_ph: "Tālrunis, lai saņemtu ziņojuma kopiju",
            lastError: "Pedējā kļūda",
            tarifsuf: "(EUR/10000)",
            limit: "Mēneša kredīts",
            range: "Periods",
            completed: "Status",
            amount: "Summa",
            remain: "Kontā",
            comment: "Komentārs",
            sourcetask: "Skatīt",

            impcol: "Lauks ",
            newkey: "Nosaukums",
            newval: "Dati",
            phstatus: "Izmantot",
            number: "Tālrunis",
            file: "Fails ar tālruņu numuru sarakstu",
            phfile: "Ielādēt no faila",
            list: "Saņēmēju saraksts",
            template: "Ziņojuma sagatave",
            type: "Izsūtnes veids",
            isAdmin: "Administrators",
            newpassword: "ievadiet jaunu paroli",
            country: "Valsts",
            provider: "Mobilo sakaru operators",
            state: "Pārbaudes status",
            settings: "Uzstādījumi",
            price: "Kopējā cena",
            msgprice: "Ziņojuma kopēja cena",
            cprice: "Cena",
            rprice: "Reāla cena",
            recipient: "Tālruņa numurs",
            sended: "Nosūtīšanas datums",
            count: "SMS skaits",
            cparts: "Ziņojumu skaits",
            rparts: "Reāls SMS skaits",
            respcode: "Atbildes kods",
            respdesc: "Atbildes apraksts",
            isutf: "Satur īpašos simbolus",
            size: "Simbolu skaits",
            event: "Notikumi",
            user: "Lietotājs",
            task: "Izsūtne",
            debit: "Konta atlikums",
            tarif: "Tarifs",
            smsapi: "SMS api",
            user_name: "Lietotāja vārds",
            company: "Uzņēmuma nosaukums",
            action: "",
            ended: "Pabeigts",
            complete: "Kļūda",
            pos: "#",
            text: "Ziņojuma teksts",
            name: "Nosaukums",
            message: "Ziņojuma teksts",
            created: "Izveidots",
            updated: "Mainīts",
            scheduled: "Nosūtīšanas laiks",
            recipients: "Saņēmēju skaits",
            status: "Status",
            sender: "Nosūtītājs",
            delimiter: "Sadalitājs",
            start: {
                lbl: "Izsūtnes sākuma laiks",
                ph: "Norādiet izsūtīšanas laiku, pēc noklusējuma uzreizs"
            }
        },
        delims: [
            { "value": ",", "text": "Komats" },
            { "value": ";", "text": "Semikols" },
            { "value": "\t", "text": "Tab" },
        ],
        task_types: [
            { "value": 0, "text": "SMS" },
            { "value": 1, "text": "E-pasts" },
        ],
        recStatus: [
            { "value": 1, "text": "Aktīvs" },
            { "value": 0, "text": "Bloķēts" },
        ],
        button: {
            cancel: "Atcelt",
            login: "Ieiet",
            reset: "Atcelt",
            delete: "Dzēst",
            edit: "Rediģēt",
            update: "Saglabāt",
            schedule: "Ieplānot izsūtīšanu",
            stop: "Atcelt izsūtīšanu",
            now: "Sākt izsūtīšanu uzreizs",
            create: "Izveidot",
            apply: "Piemērot",
            copy: "Kopēt",
            resend: "Atkārtot izsūtīšanu",
            archive: "Dzēst",
            setdate: "Uzstādīt izsūtīšanas laiku",
            impremove: "Dzēst kļūdainos ierakstus",
            edittask: "Personalizēt ziņojumu"
        },
        login: {
            title: "Autorizācija",
            login: "Lietotājs",
            pass: "Parole"
        },
        error: {
            required: "Obligāti aizpildīt",
            date: "Lūdzu izvēlēties korektu datumu un laiku",
            phone: "Nekorekts tālruņa numurs",
            login: "Lietotāja vārds vai parole nepareizi!",
            paramname: "Nosaukums tikai ar latīņu alfabēta burtiem vai cipariem"
        },
        dialog: {
            newtask: "Jauns uzdevums sūtīšanai",
            createlist: "Saņēmēju saraksta izveidošana",
            plane: "Nosūtīšanas laika ieplānošana",
            editmsg: "Rediģēt izsūtni",
            editlistrec: "Rediģēt saņēmējus",
            edit_template: "SMS ziņojuma teksts",
            copylist: "Saglabāt izvēlētos",
            ttl: {
                delete: "Apstiprināšana",
                deleteList: "Apstiprināšana",
                deleteNumber: "Apstiprināšana",
                deleteParam: "Apstiprināšana",
                deleteTemplate: "Apstiprināšana",
                deleteImportRow: "Apstiprināšana",
                deleteImportCol: "Apstiprināšana",
                stop: "Apstiprināšana",
                start: "Apstiprināšana",
                archive: "Apstiprināšana",
                reset: "Apstiprināšana",
                save: "Bridinājums",
                param: "Izmaiņas datos {param} "
            },
            txt: {
                delCompany: "Dzēst uzņēmumu ?",
                delete: "Izsūtnes dzēšana ?",
                deleteList: "Dzēst tālruņu sarakstu ?",
                deleteNumber: "Dzēst tālruni no saraksta ?",
                deleteImportRow: "Dzēst ierakstu ?",
                deleteImportCol: "Dzēst parametru ?",
                deleteTemplate: "Dzēst sagatavi no saraksta ?",
                deleteParam: "Dzēst šo parametru visiem kontaktiem?",
                start: "Palaist izsūtni?",
                stop: "Apturēt izsūtni?",
                archive: "Dzēst šo izsūtni?",
                reset: "Atcelt izsūtni?",
                save: "Saraksta dati ir mainīti, bet nav saglabāti!"
            },
            ico: {
                delete: "mdi-trash-can-outline",
                deleteList: "mdi-trash-can-outline",
                deleteNumber: "mdi-trash-can-outline",
                deleteTemplate: "mdi-trash-can-outline",
                deleteImportCol: "mdi-trash-can-outline",
                deleteImportRow: "mdi-trash-can-outline",
                deleteParam: "mdi-trash-can-outline",
                stop: "mdi-close-thick",
                reset: "mdi-close-thick",
                archive: "mdi-trash-can-outline",
                start: ""
            },
            btn: {
                delete: "Dzēst",
                deleteList: "Dzēst",
                deleteParam: "Dzēst",
                deleteTemplate: "Dzēst",
                deleteNumber: "Dzēst",
                deleteImportRow: "Dzēst",
                deleteImportCol: "Dzēst",
                start: "Palaist",
                stop: "Apturēt",
                archive: "Dzēst",
                reset: "Atcelt",
                nosave: "Iziet bez saglābāšanas",
                saveclose: "Iziet un saglābāt",
                cancel: "Atcelt",
            }
        }
    },
}

let l = localStorage.getItem("lang");

if (l == null) l = "en";
const i18n = new VueI18n({
    locale: l, // set locale
    silentTranslationWarn: false,
    messages // set locale messages
})

export default i18n;
